export default "__VITE_ASSET__4XLFdu_u__"